module.exports = __webpack_public_path__ + "static/media/cross_stroke.940bc448.svg";